module.exports = __webpack_public_path__ + "static/media/thunder.e1283761.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/thunder.gif
// module id = 52
// module chunks = 0